export default {
  getAdBreaks: state => state.adBreaks,
  getAdBreak: state => (typeId, index) => {
    const { adBreaks } = state
    const arrayOfTypeName = adBreaks.filter(x => x.adBreakTypeId === typeId)
    const singleAdBreak = arrayOfTypeName[index]
    return singleAdBreak
  },
  getAdBreakTagUrl: state => (typeId, index) => {
    const { adBreaks } = state
    const arrayOfTypeName = adBreaks.filter(x => x.adBreakTypeId === typeId)
    return arrayOfTypeName[index]?.waterfallTags
  },
}
